export const samlConfig = [
    {
        archetype: 'cmisa',
        email: 'sso@johncockerill.com'
    }
];
